import {
  SET_STANDINGS,
  SET_LOADING,
  SET_CURRENT_SEASON,
  SET_CURRENT_TOURNAMENT,
  SET_SEASONS,
  SET_GAMES
} from './standings_actions';

const initialState = {
  standings: [],
  games: [],
  loading: false,
  currentSeason: null,
  currentTournament: null
};

export default function standingsReducer(state = initialState, action) {
  switch (action.type) {
    case SET_STANDINGS:
      return {
        ...state,
        standings: action.payload
      };
    case SET_LOADING:
      return {
        ...state,
        loading: action.payload
      };
    case SET_CURRENT_SEASON:
      return {
        ...state,
        currentSeason: action.payload
      };
    case SET_CURRENT_TOURNAMENT:
      return {
        ...state,
        currentTournament: action.payload
      };
    case SET_SEASONS:
      return {
        ...state,
        seasons: action.payload
      };
    case SET_GAMES:
      return {
        ...state,
        games: action.payload
      };
    default:
      return state;
  }
}
